import src from "IMAGE";
export default { src, width: 455, height: 95, blurWidth: 0, blurHeight: 0};
